import { Modal } from '@finbeat/react-toolkit';
import ControlButtons from 'components/Workplaces/Order/OrderInfo/Additions/ControlButtons';
import OrderUnsavedChangesConfirm from 'components/Workplaces/Order/OrderUnsavedChangesConfirm';
import { PreorderInfoProvider, usePreorderInfoContext } from 'providers/PreorderInfoProvider';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { usePreorderWorkplaceState } from '../Preorder';
import PreorderInfo from './PreorderInfo';

type PreorderChangeModalProps = {
    isOpen: boolean;
    toggle: () => void;
};

const PreorderModal = ({ isOpen, toggle }: PreorderChangeModalProps) => {
    const className = 'order-change-modal';
    const { t } = useTranslation();
    const modalRef = useRef(null);
    const { orderDetails, isDirty, checksTabFormRef } = usePreorderInfoContext();
    const [isOpenNotify, setOpenNotify] = useState(false);

    const toggleModal = (dirty?: boolean) => {
        dirty ? setOpenNotify((prev) => !prev) : toggle();
    };

    return orderDetails ? (
        <Modal
            size="xl"
            isOpen={isOpen}
            toggle={() => toggleModal(isDirty)}
            innerRef={modalRef}
            scrollable
        >
            <ModalHeader toggle={() => toggleModal(isDirty)}>
                {`${t('BackOfficeOrder')}`}
                {` #${orderDetails?.orderGeneral.orderId ?? orderDetails.id}`}
            </ModalHeader>
            <ModalBody className={`${className}__body`}>
                <PreorderInfo isModal generalInfo={orderDetails} modalRef={modalRef} />
            </ModalBody>
            {orderDetails?.orderGeneral.orderId && (
                <ModalFooter className="modal-footer justify-content-between">
                    <ControlButtons
                        onNextSubmit={() => {
                            checksTabFormRef.current?.requestSubmit();
                        }}
                        info={{
                            id: orderDetails.orderGeneral.orderId,
                            orderGeneral: {
                                ...orderDetails.orderGeneral,
                                clientId: orderDetails.orderGeneral.clientId ?? 0,
                            },
                        }}
                        cancelAction={toggleModal}
                    />
                </ModalFooter>
            )}
            <OrderUnsavedChangesConfirm
                isOpen={isOpenNotify}
                closeNotify={() => setOpenNotify(false)}
                closeWindow={toggle}
            />
        </Modal>
    ) : (
        <></>
    );
};

const PreorderChangeModal = (props: PreorderChangeModalProps) => {
    const { currentItem } = usePreorderWorkplaceState();
    return (
        <PreorderInfoProvider orderDetails={currentItem} onSubmitOrderSuccess={props.toggle}>
            <PreorderModal {...props} />
        </PreorderInfoProvider>
    );
};

export default PreorderChangeModal;
